import { render, staticRenderFns } from "./UploadReport.vue?vue&type=template&id=4270bafc&scoped=true"
import script from "./UploadReport.vue?vue&type=script&lang=js"
export * from "./UploadReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4270bafc",
  null
  
)

export default component.exports